// İçerik kısa kaldığında her sütunun en alttaki kartı alt şeridin (footer) bir yerleşim birimi üstüne kadar uzar;
// kartların altı boş sayfa zemini olarak kalmaz. Sayfa yapıları farklı olduğu için (düz liste, sol menülü kabuk,
// iç içe satırlar, altında düğme satırı olan formlar) CSS zinciri yerine ölçerek yapılır:
// - Yüzey: üst seviye kart (başka kartın içinde olmayan).
// - Sütunun son kartı: altında (yatayda örtüşen) başka kart olmayan yüzey. Aynı sütunda altında kart dışı içerik
//   (ör. form düğmeleri) varsa onun payı düşülür.
// Her hesaplama önce önceki min-height'ları temizler: içerik büyüyünce kartlar gereksiz uzun kalmaz; aynı sonuç
// tekrar yazıldığı için ResizeObserver döngüye girmez. Sayfa zaten pencereden uzunsa hiçbir kart değişmez.

const SURFACE = '.iq-card, .est-leftnav__card, .est-form__card, .est-nav-overview, .est-form > .product-help';
// Özet kartı (tutar / kırılım, components/smart/smartDuoBox) içeriği kadardır ve uzatılmaz; altında durduğu yüzey için
// kart dışı içerik sayılır, yani uzamayı üstündeki kart (tablo) alır ve şerit alt şeridin üstüne oturur.
const SUMMARY = '.vega-sum__card';
const isStretchable = el => el.matches(SURFACE) && !el.matches(SUMMARY);
const MARK = 'vegaFillHeight';

function isVisible(el) {
  const style = getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden' || style.position === 'fixed' || style.position === 'absolute') return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

// Yapışkan öğe (formun aksiyon çubuğu) ekranın altına yapışınca kartın üstünde ölçülüyor, kart dışı içerik sayılmıyor
// ve uzun sayfada bile son kart çubuk + G kadar uzuyordu. Ölçüm akıştaki yerinde yapılır.
function flowRect(el) {
  if (getComputedStyle(el).position !== 'sticky') return el.getBoundingClientRect();
  const inline = el.style.position;
  el.style.position = 'static';
  const rect = el.getBoundingClientRect();
  el.style.position = inline;
  return rect;
}

function overlapsHorizontally(a, b) {
  return Math.min(a.right, b.right) - Math.max(a.left, b.left) > 20;
}

// Yüzeyin altında, kök içinde akışta onu izleyen içerik: yüzeyden köke kadar her atanın sonraki kardeşleri.
function followingContent(surface, root) {
  const rect = surface.getBoundingClientRect();
  let bottom = rect.bottom;
  let hasSurfaceBelow = false;
  for (let node = surface; node && node !== root; node = node.parentElement) {
    for (let sibling = node.nextElementSibling; sibling; sibling = sibling.nextElementSibling) {
      if (sibling.matches('.iq-footer, .iq-top-navbar') || !isVisible(sibling)) continue;
      const siblingRect = flowRect(sibling);
      if (siblingRect.top < rect.bottom - 1 || !overlapsHorizontally(rect, siblingRect)) continue;
      const surfaces = isStretchable(sibling) ? [sibling] : [...sibling.querySelectorAll(SURFACE)].filter(isStretchable);
      if (surfaces.some(inner => isVisible(inner) && overlapsHorizontally(rect, inner.getBoundingClientRect()))) {
        hasSurfaceBelow = true;
        return { hasSurfaceBelow, bottom };
      }
      bottom = Math.max(bottom, siblingRect.bottom);
    }
  }
  return { hasSurfaceBelow, bottom };
}

export function fillLayoutHeight(contentPage) {
  if (!contentPage) return;
  const footer = contentPage.querySelector(':scope > .iq-footer');
  if (!footer) return;

  contentPage.querySelectorAll(`[data-${MARK.replace(/[A-Z]/g, c => '-' + c.toLowerCase())}]`).forEach((el) => {
    el.style.removeProperty('min-height');
    delete el.dataset[MARK];
  });

  const gap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vega-gap')) || 12;
  const limit = footer.getBoundingClientRect().top - gap;

  const surfaces = [...contentPage.querySelectorAll(SURFACE)]
    .filter(el => !el.closest('.iq-top-navbar, .iq-footer, .modal, .vega-hmenu') && !el.parentElement.closest(SURFACE) && isVisible(el));

  const updates = [];
  surfaces.forEach((surface) => {
    if (!isStretchable(surface)) return;
    const { hasSurfaceBelow, bottom } = followingContent(surface, contentPage);
    if (hasSurfaceBelow) return;
    const grow = limit - bottom;
    if (grow > 0.5) updates.push([surface, surface.getBoundingClientRect().height + grow]);
  });

  // Ölçümler bitmeden yazılmaz: yazılan her min-height sonraki yüzeylerin ölçüsünü kaydırırdı.
  updates.forEach(([surface, height]) => {
    surface.style.minHeight = `${height}px`;
    surface.dataset[MARK] = '1';
  });
}
